import { Outlet, useMatch } from 'react-router-dom'
import { TopNav } from './TopNav'
import { GlobalLoadingBar } from './GlobalLoadingBar'
import { ToastProvider } from './Toast'
import { DocumentTabsProvider } from '../lib/useDocumentTabs'
import { useDocument } from '../lib/queries'

/** 라우트 전환마다 unmount 되지 않는 최상위 shell.
 *  TopNav + 글로벌 progress bar + Outlet (자식 라우트 본문).
 *  TabBar 는 DocumentView 안에서만 노출 (split-main 영역 한정, 사이드바와 분리). */
export function AppShell() {
  // 라우트별 group/project context 추출
  // - /projects/:projectKey/... → URL 에서 직접
  // - /d/:uuid[/edit|/versions] → document fetch 후 projectKey 추출 (TanStack Query cache 공유)
  const projectMatch = useMatch('/projects/:projectKey/*')
  const docMatchExact = useMatch('/d/:uuid')
  const docMatchSub = useMatch('/d/:uuid/*')
  const docUuid = docMatchExact?.params.uuid ?? docMatchSub?.params.uuid
  const { data: doc } = useDocument(docUuid)
  const currentProjectKey = projectMatch?.params.projectKey ?? doc?.projectKey ?? undefined

  return (
    <DocumentTabsProvider>
      <ToastProvider>
        <GlobalLoadingBar />
        <TopNav currentProjectKey={currentProjectKey} />
        <Outlet />
      </ToastProvider>
    </DocumentTabsProvider>
  )
}
